import { useTranslation } from 'react-i18next';
import DeleteWorkScheduleSlotRecurrenceForm from '@/components/forms/delete-work-schedule-slot-recurrence/delete-work-schedule-slot-recurrence-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { WorkScheduleSlotSequence } from '@/hooks/queries/use-get-office-work-schedules-slots';
import {
  DeleteWorkScheduleSlotEventOccurence,
  DeleteWorkScheduleSlotRecurrenceModalApi,
  selectDeleteWorkScheduleSlotRecurrenceViewModel,
} from './delete-work-schedule-slot-recurrence-modal.viewmodel';

type DeleteWorkScheduleSlotRecurrenceModalProps = {
  slot: {
    id: string;
    sequence: WorkScheduleSlotSequence;
  };
  eventOccurrence: DeleteWorkScheduleSlotEventOccurence;
} & DeleteWorkScheduleSlotRecurrenceModalApi;

export const DeleteWorkScheduleSlotRecurrenceModal = ({
  slot,
  eventOccurrence,
  onDeleteOccurenceSuccess,
  onStopSeriesSuccess,
  onClose,
  onCancel,
}: DeleteWorkScheduleSlotRecurrenceModalProps) => {
  const { t } = useTranslation();

  const viewModel = selectDeleteWorkScheduleSlotRecurrenceViewModel({
    slotId: slot.id,
    sequence: slot.sequence,
    eventOccurrence,
    api: {
      onDeleteOccurenceSuccess,
      onStopSeriesSuccess,
      onClose,
      onCancel,
    },
  });

  return (
    <Dialog open={viewModel.data.show}>
      <DialogContent
        className="sm:max-w-2xl"
        aria-describedby={undefined}
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('delete-work-schedule-slot-recurrence-modal.title')}
          </DialogTitle>
        </DialogHeader>

        <DeleteWorkScheduleSlotRecurrenceForm
          form={viewModel.data.form}
          sequence={slot.sequence}
          occurrence={eventOccurrence}
        />

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.cancel}
          >
            {t('btn.cancel')}
          </Button>

          <Button
            variant="destructive"
            onClick={viewModel.api.submit}
            loading={viewModel.data.deleting}
          >
            {t('btn.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
